import * as React from 'react'
import { FormGroup, FormLabel } from 'react-bootstrap'
import { FormLabelProps } from 'react-bootstrap/FormLabel'
import * as clsx from 'clsx'
import { FormGroupProps } from 'react-bootstrap/FormGroup'
import { FormControlWithStatus } from '@components/form-controls/form-control-with-status'
import { FieldError } from 'react-hook-form'

export interface FormControlWithLabelProps {
  label?: React.ReactNode
  inputName: string
  formLabelProps?: FormLabelProps
  formGroupProps?: FormGroupProps
  isLoading?: boolean
  isSucceed?: boolean
  isFailed?: boolean
  inputSuffix?: React.ReactNode
  children: React.ReactNode
  renderError?: (error: FieldError) => React.ReactNode
  formControlWrapperClassName?: string
}

export const FormControlWithLabel = ({
  label,
  inputName,
  formLabelProps,
  formGroupProps,
  isLoading,
  isSucceed,
  isFailed,
  inputSuffix,
  children,
  renderError,
  formControlWrapperClassName,
}: FormControlWithLabelProps): React.ReactElement => (
  <FormGroup {...formGroupProps} className={clsx('mt-2', formGroupProps?.className)} controlId={inputName}>
    {label && (
      <FormLabel {...formLabelProps} className={clsx('text-muted mb-0 d-flex font-size-sm', formLabelProps?.className)}>
        {label}
      </FormLabel>
    )}
    <FormControlWithStatus
      inputName={inputName}
      isLoadingVisible={!!isLoading}
      isFailed={!isLoading && isFailed}
      isSucceed={!isLoading && isSucceed}
      inputSuffix={inputSuffix}
      renderError={renderError}
      formControlWrapperClassName={formControlWrapperClassName}
    >
      {children}
    </FormControlWithStatus>
  </FormGroup>
)
